var _g, _path, _path2, _path3, _path4;

var _excluded = ["title", "titleId"];

function _extends() { _extends = Object.assign ? Object.assign.bind() : function (target) { for (var i = 1; i < arguments.length; i++) { var source = arguments[i]; for (var key in source) { if (Object.prototype.hasOwnProperty.call(source, key)) { target[key] = source[key]; } } } return target; }; return _extends.apply(this, arguments); }

function _objectWithoutProperties(source, excluded) { if (source == null) return {}; var target = _objectWithoutPropertiesLoose(source, excluded); var key, i; if (Object.getOwnPropertySymbols) { var sourceSymbolKeys = Object.getOwnPropertySymbols(source); for (i = 0; i < sourceSymbolKeys.length; i++) { key = sourceSymbolKeys[i]; if (excluded.indexOf(key) >= 0) continue; if (!Object.prototype.propertyIsEnumerable.call(source, key)) continue; target[key] = source[key]; } } return target; }

function _objectWithoutPropertiesLoose(source, excluded) { if (source == null) return {}; var target = {}; var sourceKeys = Object.keys(source); var key, i; for (i = 0; i < sourceKeys.length; i++) { key = sourceKeys[i]; if (excluded.indexOf(key) >= 0) continue; target[key] = source[key]; } return target; }

import * as React from "react";

function SvgIconUniformity(_ref, svgRef) {
  var title = _ref.title,
      titleId = _ref.titleId,
      props = _objectWithoutProperties(_ref, _excluded);

  return /*#__PURE__*/React.createElement("svg", _extends({
    xmlns: "http://www.w3.org/2000/svg",
    width: 1243,
    height: 1024,
    viewBox: "0 0 1243 1024",
    ref: svgRef,
    "aria-labelledby": titleId
  }, props), title ? /*#__PURE__*/React.createElement("title", {
    id: titleId
  }, title) : null, _g || (_g = /*#__PURE__*/React.createElement("g", {
    id: "icomoon-ignore"
  })), _path || (_path = /*#__PURE__*/React.createElement("path", {
    d: "M473.138 62.286h-95.168l-320.113 922.846h95.169l320.113-922.846z"
  })), _path2 || (_path2 = /*#__PURE__*/React.createElement("path", {
    d: "M977.137 62.286h-95.744l-319.536 922.846h95.168l320.112-922.846z"
  })), _path3 || (_path3 = /*#__PURE__*/React.createElement("path", {
    d: "M1228.566 62.286h-95.744l-319.539 922.846h95.173l320.11-922.846z"
  })), _path4 || (_path4 = /*#__PURE__*/React.createElement("path", {
    d: "M309.286 985.3h95.745l240.517-694.443h-95.745l-240.516 694.443z"
  })));
}

var ForwardRef = /*#__PURE__*/React.forwardRef(SvgIconUniformity);
export default __webpack_public_path__ + "static/media/icon-uniformity.5ce0744f05aa3a361cf97a91c582bbe5.svg";
export { ForwardRef as ReactComponent };